import { getYear, parseISO } from 'date-fns';

import { DateSource } from '../../../types/date';

export const DATE_TOKEN_DETAILED = "MMMM Lo, yyyy 'at' h:mmaaa";

export const toDateObject = (date: DateSource): Date => (typeof date === 'string' ? parseISO(date) : new Date(date));

export const currentYear = () => getYear(new Date());
